/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Video_Credit_Trial_TitleInputs */

const en_video_credit_trial_title = /** @type {(inputs: Video_Credit_Trial_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This video uses ${i?.cost} credits. Start with a 1-credit 480p preview.`)
};

const es_video_credit_trial_title = /** @type {(inputs: Video_Credit_Trial_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este video usa ${i?.cost} créditos. Empieza con una vista previa de 1 crédito a 480p.`)
};

/**
* | output |
* | --- |
* | "This video uses {cost} credits. Start with a 1-credit 480p preview." |
*
* @param {Video_Credit_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const video_credit_trial_title = /** @type {((inputs: Video_Credit_Trial_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Credit_Trial_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_credit_trial_title(inputs)
	return es_video_credit_trial_title(inputs)
});